import React from 'react';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import useVerifySessionAuth0 from '../../Hooks/useVerifySessionAuth0';
import { useAuth0 } from '@auth0/auth0-react';
import { useStore } from '../../Store/storeProvider';
import getSegmentAndGaFromCookies from '../../Helpers/getSegmendAndGaFromCookies';
import {
    setOriginIdCookie,
    getAuth0Cookies,
} from '../../Helpers/Auth0CookieManager';
import useValidateUserAuth0Handler from '../../Hooks/useValidateUserAuth0Handler';

const Auth0GoogleLogin = () => {
    const { loginWithRedirect } = useAuth0();
    const { Config } = useStore();
    const { segment, ga } = getSegmentAndGaFromCookies();
    const [validateUser] = useValidateUserAuth0Handler();

    const googleLoginHandler = async (isVerified) => {
        const userEmail = Config.UserEmail;
        const userHaveCookies = getAuth0Cookies();

        if (userHaveCookies) {
            await validateUser(Config.URLCallback);
        } else if (userEmail) {
            setOriginIdCookie(Config.SitioId, Config.URLCallback);
            loginWithRedirect({
                connection: 'google-oauth2',
                login_hint: userEmail,
                modo: `${Config.Modo}`,
                origen: `${Config.SitioId}`,
                redirectUri: `${
                    window.location.origin
                }/auth0-callback/?callback=${window.btoa(Config.URLCallback)}`,
                segment: segment,
                ga: ga,
                event_name: "googleOneTap"
            });
        } else {
            window.location = `${window.location.origin}/auth0-login/${
                Config.Modo
            }/${Config.SitioId}/?callback=${window.btoa(Config.URLCallback)}`;
        }
    };

    const [isLoadingProcess] = useVerifySessionAuth0(googleLoginHandler);

    return (
        <div className="callback-view containerSpinner">
            <LoadingSpinner isLoading={isLoadingProcess}></LoadingSpinner>
        </div>
    );
};
export default Auth0GoogleLogin;
